import { gql } from "@apollo/client";

export const GET_SUPERVISION_FORM = gql`
  query GetAdultSupervisionForm($healthId: String!) {
    getAdultSupervisionForm(healthId: $healthId) {
      id
      firstName
      lastName
      documentType {
        name
      }
      documentNumber
      phoneNumber
    }
  }
`;
